import { apiRequest } from "../util/apiUtils";

export const postList = async (params) => {
  try {
    const res = await apiRequest("get", `task/list`, {
      queries: { ...params, type: "Post" }, //post-tost backend eng
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const postAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `task/${payload?.id ? "edit" : "add"}`,
      {
        body: { ...payload, type: "Post" },
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `task/delete`, {
      body: { ...payload },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `task/status`, {
      body: { ...payload, type: "Post" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const postFeaturedChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `task/featured`, {
      body: { ...payload, type: "Post" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const postDetails = async (postId) => {
  try {
    // const res = await apiRequest("get", `post/detail`, {
    //   queries: params,
    // });
    const res = await apiRequest("get", `task/detail/${postId}`, {
      queries: { type: "Post" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
